const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconAgregar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.61 23.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.16,18.53a.51.51,0,0,1-.36.15.5.5,0,0,1-.5-.5V12.3H5.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H11.8a.5.5,0,0,1,.5.5v6.38A.48.48,0,0,1,12.16,18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.53,12.16a.48.48,0,0,1-.35.14H11.8a.5.5,0,0,1-.5-.5V5.43a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V11.3h5.88a.5.5,0,0,1,.5.5A.51.51,0,0,1,18.53,12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.1,23.61H.5A.5.5,0,0,1,0,23.1V.5A.5.5,0,0,1,.5,0H23.1a.5.5,0,0,1,.51.5V23.1A.51.51,0,0,1,23.1,23.61ZM1,22.6H22.6V1H1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgregar);
export default __webpack_public_path__ + "static/media/icon_agregar.be60550530e148f1d8676488bd1f9a78.svg";
export { ForwardRef as ReactComponent };